import { Button, Form } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ModalInput } from "../../../components/AntCostomComponents/Inputs";
import { RegisterKitBarcode } from "./register-kit-barcode-scanner";

const RegisterKitForm = ({ handleSubmit }) => {
  const { t } = useTranslation("common");
  const [form] = Form.useForm();

  function handleResultFromScanner(result) {
    form.setFieldsValue({ query: result });
  }

  const submitForm = async () => {
    const values = await form.validateFields();

    handleSubmit(values.query);
    form.resetFields(["query"]);
  };

  return (
    <div>
      <Form
        form={form}
        className="flex flex-row gap-3 justify-center items-end mb-0 flex-wrap"
        onFinish={submitForm}
        layout="vertical"
      >
        <div className="flex justify-center text-center items-baseline gap-2">
          <label>{t("kit_barcode")}</label>
          <Form.Item
            name="query"
            rules={[
              { required: true, message: t("please_enter_barcode") },
              {
                pattern: /^[0-9]{10,}$/,
                message: t("barcode_must_be_at_least_10_digits"),
              },
            ]}
            validateTrigger={["onBlur", "onSubmit"]}
          >
            <ModalInput />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {t("add")}
            </Button>
          </Form.Item>
        </div>
      </Form>
      <div className="mt-3">
        <RegisterKitBarcode setCode={handleResultFromScanner} />
      </div>
    </div>
  );
};

export default RegisterKitForm;
